export default __webpack_public_path__ + "5757e0793845e8645c66994e14efae6d.png";